export default "__VITE_ASSET__CnaZWgZs__"